'use client';

import React, { useEffect, useState } from 'react';

import { ProductLike } from './ProductLike';
import { ProductSave } from './ProductSave';
import styles from './styles.module.css';

import { Placeholder, PlaceHolderShape } from '@/components/Placeholder';
import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useProductBySlugBasicPDP } from '@/modules/product/hooks/useProductBySlugBasicPDP';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';

export function ProductInteraction() {
  const { data: productBasic } = useProductBySlugBasicPDP();
  const { data: productExtended, isLoading: productExtendedLoading } =
    useProductBySlugExtendedPDP();
  const [likeCount, setLikeCount] = useState(0);
  const { web_9180_remove_pdp_save_icon } = useExperiments([
    'web_9180_remove_pdp_save_icon',
  ]);
  const hideSaveIcon = web_9180_remove_pdp_save_icon === VARIANT_IDENTIFIER;

  useEffect(() => {
    if (productExtended?.like_count !== undefined) {
      setLikeCount(productExtended.like_count);
    }
  }, [productExtended?.like_count]);

  if (!productBasic) {
    return null;
  }

  if (productExtendedLoading) {
    return (
      <div className={styles.container}>
        <Placeholder
          shape={PlaceHolderShape.CIRCLE}
          width="44px"
          height="44px"
        />
        {!hideSaveIcon && (
          <Placeholder
            shape={PlaceHolderShape.CIRCLE}
            width="44px"
            height="44px"
          />
        )}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.buttonInteractionWrapper}>
        <ProductLike
          productId={productBasic?.id}
          hasLikedProduct={productExtended?.is_liked}
          setLikeCount={setLikeCount}
          likeCount={likeCount}
        />
      </div>
      {!hideSaveIcon && (
        <div className={styles.buttonInteractionWrapper}>
          <ProductSave
            productId={productBasic?.id}
            hasSavedProduct={productExtended?.is_saved}
          />
        </div>
      )}
    </div>
  );
}
